import { ButtonStyleType } from '../../constants/button-style-type';
import IButton from '../../models/button/IButton';
import { ApplicationSettings } from '../../models/settings';
import BaseComponentModel from './base-component-model';
import colorStyle from '../../styles/utils/variables.module.scss';
import { replaceAttrSpaceWithHyphen } from '../../utils/string-helpers/replace-attr-space-with-hyphen';
import IShouldReturnEntity from '../../api-clients/IShouldReturnEntity';
import { Entry } from 'contentful';
import { ExcludedEntitiesHelper } from '../../api-clients/page-template-clients/helpers/excluded-entities-helper';

export default class CtaButtonComponentModel extends BaseComponentModel {
  protected shouldReturnEntity(entry: Entry<any>): IShouldReturnEntity {
    const requiredFields = ['text'];
    const notEmptyFields = [];

    return this.excludedEntitiesHelper.shouldComponentBeReturned(
      this.component,
      entry,
      requiredFields,
      notEmptyFields,
    );
  }

  public excludedEntitiesHelper = new ExcludedEntitiesHelper();
  public component = 'CtaButton';
  ctaButtonFields: any;
  appSettings: ApplicationSettings;

  constructor(ctaButtonFields: any, appSettings: ApplicationSettings) {
    super('ctaButton', appSettings);

    let button: IButton;
    const buttonFields = ctaButtonFields;
    const isButtonOutlineStyled = buttonFields?.buttonStyle === ButtonStyleType.Outline;

    const ctaButtonShouldReturn = this.shouldReturnEntity(ctaButtonFields);

    if (!ctaButtonShouldReturn.shouldReturn) {
      this.exclusionReasons.push(...ctaButtonShouldReturn.shouldNotReturnReasons);
      this.isValid = false;
      return;
    }

    button = {
      buttonID: buttonFields.id
        ? buttonFields.id
        : replaceAttrSpaceWithHyphen(buttonFields.buttonName),
      buttonURL: buttonFields.url,
      buttonAriaLabel: buttonFields.buttonName,
      buttonSize: buttonFields.buttonSize,
      buttonNewTab: buttonFields.target,
      buttonStyle: buttonFields.buttonStyle,
      children: buttonFields.text,
      copyColor: isButtonOutlineStyled ? appSettings.branding.primaryColor : colorStyle.white,
      backgroundColor: isButtonOutlineStyled ? colorStyle.white : appSettings.branding.primaryColor,
      outlineColor: appSettings.branding.primaryColor,
      hoverBackgroundColor: appSettings.branding.primaryHoverColor,
      activeBackgroundColor: appSettings.branding.primaryActiveColor,
      heapIdentifier: buttonFields.id
        ? buttonFields.id
        : replaceAttrSpaceWithHyphen(buttonFields.buttonName),
    };
    this.appSettings = appSettings;
    this.ctaButtonFields = button;
  }
}
